// extracted by mini-css-extract-plugin
export default {"thoughtProcess":"analysis-panel_thoughtProcess__CqvsF","closeBtn":"analysis-panel_closeBtn__p9jks","pdfZone":"analysis-panel_pdfZone__75+-D"};